import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Button, TextInput } from "@gravity-ui/uikit";
import { RoutesList } from "@/router/routesList";
import { debounce } from "@/tools/debounce";
import { useSetPageData } from "@/tools/hooks";
import { AllUserList } from "./components/AllUserList";
import { FavoritesUserList } from "./components/FavoritesUserList";
export var UserListPage = function (props) {
    var _a = useState(""), searchQuery = _a[0], setSearchQuery = _a[1];
    var debouncedSearch = debounce(setSearchQuery, 500);
    /** Поле поиска */
    var searchChangeHandler = function (value) {
        // value.length > 2 &&
        debouncedSearch(value);
    };
    var navigate = useNavigate();
    /** Избранные пользователи */
    var favoritsClickHandler = function () {
        navigate(RoutesList.Users.getUsersFavorites());
    };
    /** Все пользователи */
    var allClickHandler = function () {
        navigate(RoutesList.Users.getUsersList());
    };
    var onDetailsClickHandler = function (userId) {
        navigate(RoutesList.Users.getUserDetails(userId));
    };
    useSetPageData({ title: "Пользователи" });
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "g-s__py_4", children: [_jsx(Button, { view: "normal", onClick: favoritsClickHandler, size: "l", selected: props.isFavorites, pin: "circle-clear", children: "\u041C\u043E\u0438 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0435" }), _jsx(Button, { view: "normal", onClick: allClickHandler, selected: !props.isFavorites, size: "l", pin: "clear-circle", children: "\u0412\u0441\u0435" })] }), _jsx(TextInput, { onUpdate: searchChangeHandler, placeholder: "Поиск", style: { marginBottom: 20 }, size: "xl" }), props.isFavorites ? (_jsx(FavoritesUserList, { searchQuery: searchQuery, onDetailsClick: onDetailsClickHandler })) : (_jsx(AllUserList, { searchQuery: searchQuery, onDetailsClick: onDetailsClickHandler }))] }));
};
